import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import pricingApi from '../../APIs/pricing';
import {
  Button,
  PageHeader,
  Pagination,
  Typography,
} from '../../designComponents';
import Table, { TableDataType } from '../../designComponents/Table';
import { ADD_PRICING_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { humanReadableDate, requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { AdminPricingMainContainer } from './style';

type Props = {};
type ParamsType = {
  page: number;
  limit: number;
};

const AdminPricing = (_props: Props) => {
  const [search] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pagination = useSelector(
    (state: RootState) => state.pricing.pagination
  );

  const pricing = useSelector((state: RootState) => state.pricing.data);

  const getAllPricing = async (myParams: MyParamsType) => {
    try {
      requestAPI(
        pricingApi.getAllPricing({ page: myParams.page, limit: myParams.limit })
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllPricing(pagination);
  }, []);
  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'Date' },
      { key: 'title', label: 'Title' },
      {
        key: 'priceDenom',
        label: 'PriceDenom',
      },
      {
        key: 'planType',
        label: 'Plan Type',
      },
      { key: 'price', label: 'Price' },

      {
        key: 'actions',
        label: 'Actions',
      },
    ],
    body: Array.isArray(pricing)
      ? pricing?.map((price) => {
          return {
            id: price._id,
            date: humanReadableDate(price.createdAt),
            title: price.title,
            priceDenom: price.priceDenom,
            planType: price.planType,
            price: price.price,
            actions: (
              <Button
                onClick={() => navigate(price._id)}
                variant="secondary"
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Details
              </Button>
            ),
          };
        })
      : [],
  };

  const handlePagination = (updatedParams: ParamsType) => {
    getAllPricing(updatedParams);
    dispatch(
      Store.Actions.update('pricing.pagination', {
        ...pagination,
        updatedParams,
      })
    );
  };
  return (
    <AdminPricingMainContainer>
      <PageHeader
        pageTitle={<Typography variant="title">Pricing</Typography>}
        handleOnSearchTextChange={() => {}}
        search={search}
        otherActions={
          <Button onClick={() => navigate(ADD_PRICING_ROUTE)}>Add Price</Button>
        }
      />
      <div className="table-container">
        <Table tableData={tableData} />
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </AdminPricingMainContainer>
  );
};

export default AdminPricing;
